import React from 'react';

import './style';

export type FormGroupProps = React.HTMLAttributes<HTMLDivElement>;

const FormGroup: React.FC<FormGroupProps> = ({ className, ...rest }: FormGroupProps) => {
  return (
    <div className={'form-group form-group-cmp ' + className} {...rest}>
      {rest.children}
    </div>
  );
}

export default FormGroup;
